// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"9061db3c","950":"0e8ac16c"}[chunkId] + ".chunk.js";
};